import React, { useRef, useState, useEffect } from 'react'
import styled from 'styled-components/macro'
import PropTypes from 'prop-types'

const SelectedFilterLabel = styled.strong`
  font-size: 11px;
  padding-top: 4px;
  display: block;
`

const SelectedFilters = function ({ currentFilters, change }) {
  const filtersRef = useRef([])
  /* eslint-disable-next-line */
  const [checkboxes, setAccordion] = useState([])
  useEffect(() => {
    change ? change() : null
    filtersRef.current.forEach(el => {
      const filterElement = el
      filterElement.classList.add('selected-cont')
      filterElement.classList.remove('filtering')
      const title = document.getElementById('summary-search-options')
      setTimeout(() => {
        if (el.getElementsByClassName('selected-filters').length > 0) {
          title.classList.add('show')
          title.parentElement.classList.add('show')
          filterElement.classList.add('filtering')
        }
      })
    })
    currentFilters.map((item, index) => {
      setAccordion(checkboxes => {
        const newArray = [...checkboxes]
        newArray[index] = counter(item) > 2 ? false : true
        return newArray
      })
    })
  }, [filtersRef.current.length])
  /* eslint-disable-next-line */
  function counter(i) {
    var parentId = 'counter-' + i.name.replace(/,|\//g, '').replace(/ /g, '-')
    var parent = document.getElementById(parentId)
    if (parent) {
      var el = parent.getElementsByClassName('selected-filters').length
    }
    return el ? el : null
  }
  function setRef(el, index) {
    filtersRef.current[index] = el
  }
  /* eslint-disable-next-line */
  function accordionChange(index) {
    setAccordion(checkboxes => {
      const newArray = [...checkboxes]
      newArray[index] = !checkboxes[index]
      return newArray
    })
  }

  return (
    <>
      {currentFilters.map((item, index) => (
        <div key={item.name} ref={el => setRef(el, index)} /* eslint-disable-next-line */>
          <input
            type="checkbox"
            className="selected-filters-accordion"
            id={`selected-${item.name}`}
            checked={true}
            readOnly
          />
          <label htmlFor={`selected-${item.name}`}>
            <SelectedFilterLabel>
              Selected{' '}
              <span className={'filter-type ' + item.name.replace(/ /g, '_')}>
                {item.name
                  ? item.name
                      .toLowerCase()
                      .replace('basic filters', 'basic data')
                      .replace('additional filters', 'additional data')
                      .replace('additional document filters', 'additional document')
                      .replace('programmes', 'programme search')
                      .replace('basic criteria', 'text and general search')
                  : 'No filters selected'}
              </span>{' '}
              Filters: {/*!checkboxes[index] ? counter(item) + ' (expand)' : ''*/ ''}
            </SelectedFilterLabel>
          </label>
          <div id={'counter-' + item.name.replace(/,|\//g, '').replace(/ /g, '-')} className="cont">
            {item.filters.map((filter, idx) => {
              const FilterComponent = filter.componentType
              return (
                <div key={`${idx}_${filter.title}`} className={`counter-${index}_${filter.title}`}>
                  <FilterComponent
                    /* eslint-disable-next-line react/no-array-index-key */
                    key={`${idx}_${filter.title}`}
                    type={filter.type}
                    macroType={filter.macroType}
                    filterData={filter.data}
                    values={filter.values}
                    title={filter.title}
                    info={filter.info}
                    keyWord={filter.keyWord ? filter.keyWord : null}
                    customTop={filter.customTop ? filter.customTop : null}
                    showFilter={false}
                    isSummary
                    selection={true}
                  />
                </div>
              )
            })}
          </div>
        </div>
      ))}
    </>
  )
}

SelectedFilters.propTypes = {
  currentFilters: PropTypes.array,
  change: PropTypes.func
}

export default SelectedFilters
